import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import i18n from '~shared/utils/i18n';
import {
    PER_PAGE_COUNT,
    I18N_MADE_FOR_YOU_ALL_ALL_TEXT,
    I18N_MADE_FOR_YOU_PREV,
    I18N_MADE_FOR_YOU_NEXT,
    MADE_FOR_YOU_GTM_PREVIOUS_SELECTIONS,
    MADE_FOR_YOU_GTM_NEXT_SELECTIONS,
    MADE_FOR_YOU_GTM_ADD_ALL_TO_BET_SLIP,
    MADE_FOR_YOU_GA_COMPONENT_HOME_TYPES,
} from '~scenes/madeforyou/constants';
import {
    selectVisibleBetCardSelectionIds,
    selectBetCards,
    selectCurrentPage,
    selectActiveTab,
} from '~scenes/madeforyou/app/selectors/mfySelectors';
import {
    setCurrentPage,
    incrementCurrentPage,
    decrementCurrentPage,
} from '~scenes/madeforyou/app/actions/mfyActions';
import { useBetslipSelectionsIds } from '~SpectateStore/hooks/betslipHooks';
import {
    addSelectionsToBetslip,
} from '~Betslip/interface/interactions';
import { getGtmPrefix } from '~scenes/madeforyou/utils';

/**
 * Made For You homepage widget and Made For You page footer component
 * consist of 'previous & next' and 'add all' functions.
 */

const Footer = () => {
    const dispatch = useDispatch();
    const betCards = useSelector(selectBetCards);
    const activeTab = useSelector(selectActiveTab);
    const currentPage = useSelector(selectCurrentPage);
    const betcardSelectionIds = useSelector(selectVisibleBetCardSelectionIds);
    const betslipSelections = useBetslipSelectionsIds();
    const gtmPrefix = getGtmPrefix(activeTab, true);
    const maxPage = Math.ceil(betCards.length / PER_PAGE_COUNT);
    const shouldShowNextPrevButtons = maxPage > 1;
    const shouldShowAddAllButton = betcardSelectionIds.length > 1;
    const betLocate = MADE_FOR_YOU_GA_COMPONENT_HOME_TYPES.get(activeTab);
    const selectionFlags = betcardSelectionIds.map((id) => ({
        id: String(id),
        bet_locate: betLocate,
    }));

    const isAllSelectionsSelected = useMemo(
        () => betcardSelectionIds.every((selectionId) => betslipSelections.includes(String(selectionId))),
        [betslipSelections, betcardSelectionIds]
    );

    useEffect(() => {
        dispatch(setCurrentPage(1));
    }, [activeTab]);

    return <>
        <div className="made-for-you-spacer" />
        <div className='made-for-you__footer'>
            {shouldShowNextPrevButtons &&
                <>
                    <button
                        disabled={currentPage === 1}
                        className='made-for-you__footer-button'
                        onClick={() => dispatch(decrementCurrentPage())}
                        data-spectate-product={`${gtmPrefix};${MADE_FOR_YOU_GTM_PREVIOUS_SELECTIONS}`}
                    >
                        {i18n.t(I18N_MADE_FOR_YOU_PREV)}
                    </button>
                    <div className='made-for-you__footer-seperator'/>
                    <button
                        disabled={currentPage === maxPage}
                        className='made-for-you__footer-button'
                        onClick={() => dispatch(incrementCurrentPage())}
                        data-spectate-product={`${gtmPrefix};${MADE_FOR_YOU_GTM_NEXT_SELECTIONS}`}
                    >
                        {i18n.t(I18N_MADE_FOR_YOU_NEXT)}
                    </button>
                </>
            }
            <div className="made-for-you-spacer" />
            {shouldShowAddAllButton &&
                <button
                    disabled={isAllSelectionsSelected}
                    className='made-for-you__footer-button made-for-you__footer-button-add-all'
                    onClick={() => addSelectionsToBetslip(betcardSelectionIds, '', selectionFlags)}
                    data-spectate-product={`${gtmPrefix};${MADE_FOR_YOU_GTM_ADD_ALL_TO_BET_SLIP}`}
                >
                    {i18n.t(I18N_MADE_FOR_YOU_ALL_ALL_TEXT)}
                </button>
            }
        </div>
    </>;
};

export default Footer;
